import { render } from "./returning.vue?vue&type=template&id=0e884548&scoped=true"
import script from "./returning.vue?vue&type=script&lang=js"
export * from "./returning.vue?vue&type=script&lang=js"

import "./returning.vue?vue&type=style&index=0&id=0e884548&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e884548"]])

export default __exports__